<template>
    <v-dialog v-model="dialog" max-width="1500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            dark
            class="mx-2"
            v-bind="attrs"
            v-on="on"
            >เพิ่ม/แก้ไขลูกค้า</v-btn>
        </template>

        <v-card outlined class="pa-3">
                <v-card-title ><strong>{{$t('customer_title')}}</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">

                    <v-row class="mt-4" >
                        <v-col cols="8">
                            <FragmentSelectStation 
                                
                                @onchange="onStationChange" 
                                :have_label="false"
                                :station_code="editedItem.station_code"
                            >
                            </FragmentSelectStation>
                        </v-col>
                        <v-col>
                            <v-select
                                v-model="editedItem.report_duedate"
                                :items="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]"
                                label="วันที่ตัดรอบบิล"
                                return-object
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-form ref="formData" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-text-field :rules="[rules.required]" v-model="editedItem.customer_name" label="ชื่อลูกค้า"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field :rules="[rules.required]" v-model="editedItem.tax_id" label="เลขที่ประจำตัวเสียภาษี"></v-text-field>
                        </v-col>
                    </v-row>
                   <v-row>
                       <v-col>
                            <v-text-field :rules="[rules.required]"  maxLength="5" v-model="editedItem.branch_code" label="รหัสสาขา"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field  v-model="editedItem.branch_name" label="ชื่อสาขา"></v-text-field>
                        </v-col>
                        
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field :rules="[rules.required]" v-model="editedItem.address" label="ที่อยู่"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field :rules="[rules.required]" v-model="editedItem.postcode" label="รหัสไปรษณีย์"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="editedItem.phone_number" label="โทรศัพท์1"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="editedItem.phone_number2" label="โทรศัพท์2"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="editedItem.contact_name" label="ชื่อผู้ติดต่อ"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="editedItem.email1" label="อีเมล์สำหรับส่งเอกสารทางบัญชี"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="editedItem.email2" label="อีเมล์สำหรับข้อมูลการใช้งาน"></v-text-field>
                        </v-col>
                    </v-row>
                    </v-form> 
                </div>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDialog">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<style scoped>
    .right-text {
        text-align: right;
    }
</style>
<script>

import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'

import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'

export default {
    components: {
        FragmentSelectStation
    },
    name: 'DlgCustomer',
    data: () => ({
        rules: {
            required: value => !!value || 'กรุณากรอกข้อมูล.',
            requiredNumber: value => !!value && (value >= 0) || 'กรุณากรอกตัวเลขที่มีค่ามากกว่าหรือเท่ากับ 0',
        },
        isEdit: false,
        dialog: false,
        editedItem: {
            customer_name: '',
            tax_id: ''
        }
    }),
    methods: {
        onStationChange(c){
            this.editedItem.station_code = c.station_code
        },
        saveDialog() {
            if (!this.$refs.formData.validate()) {
                return;
            }
            let url = this.isEdit ? config.api.url.manage.customer.update + this.editedItem.customer_id : config.api.url.manage.customer.insert;
            var que = this.$store.commit('addLoading')
            axios.post(url, this.editedItem, { headers: Staff.getTokenHeader()}).then(() => {
                this.$store.commit('finishLoading',que)
                 this.closeDialog(true);
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error});
            });
           
        },
        closeDialog(isSuccess) {
            this.editedItem = {};
            this.dialog = false;
            this.isEdit = false;
            this.$emit("onCloseDialog", isSuccess);
        },
        show(item) {
            this.dialog = true;
            this.editedItem = item;
            this.isEdit = true;
        }
    }
}
</script>